import { useCallback } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { ResetAuthOptions, useServices } from 'core/services';
import { authenticationKeys } from 'core/utils/query-key-factory';

export const useLogout = () => {
	const { authentication, errorLogger } = useServices();

	const queryClient = useQueryClient();

	const doLogout = useCallback((options?: ResetAuthOptions) => {
		authentication.reset(options);

		// Set identity to null first so the identity query gets
		// disabled (enabled: isLoggedIn) before we touch other queries
		queryClient.setQueryData(authenticationKeys.identity, null);

		queryClient.cancelQueries();

		queryClient.removeQueries({
			predicate: query =>
				JSON.stringify(query.queryKey) !==
				JSON.stringify(authenticationKeys.identity),
		});

		errorLogger.setUser(null);
	}, []);

	return { doLogout };
};
